module.exports = __webpack_public_path__ + "static/media/Pratik Patil.cf5c03aa.jpg";